import { z } from "zod";
import { domainNameSchema } from "./domain.js";

export const dnsRecordTypeSchema = z.enum(["A", "AAAA", "CNAME", "MX", "TXT", "SRV", "CAA", "NS"]);
export type DnsRecordType = z.infer<typeof dnsRecordTypeSchema>;

export const dnsRecordSchema = z.object({
  id: z.string().optional(),
  type: dnsRecordTypeSchema,
  /** Relative name; "@" for the zone apex. */
  name: z.string().min(1),
  value: z.string().min(1),
  ttl: z.number().int().min(60).max(86_400),
  priority: z.number().int().min(0).max(65_535).optional(),
  weight: z.number().int().min(0).max(65_535).optional(),
  port: z.number().int().min(0).max(65_535).optional(),
});
export type DnsRecordDto = z.infer<typeof dnsRecordSchema>;

export const emailSetupPreviewSchema = z.object({
  domain: domainNameSchema,
  /** False when the mail platform has not provisioned the domain yet; DKIM then shows a placeholder. */
  provisioned: z.boolean(),
  records: z.array(dnsRecordSchema),
});
export type EmailSetupPreview = z.infer<typeof emailSetupPreviewSchema>;

export const emailSetupApplyResponseSchema = z.object({
  domain: domainNameSchema,
  zoneCreated: z.boolean(),
  nameservers: z.array(z.string()),
  created: z.number().int().nonnegative(),
  updated: z.number().int().nonnegative(),
  unchanged: z.number().int().nonnegative(),
  records: z.array(dnsRecordSchema),
});
export type EmailSetupApplyResponse = z.infer<typeof emailSetupApplyResponseSchema>;
